import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gdrive",
  "use": "gdrive-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"gdrive\"><path d=\"m4.142 17.467 11.802.03L19 12.648 7.04 12.45l-2.898 5.017ZM12.948 2H6.992l5.462 10.045 6.3.085L12.948 2ZM1 12.14l2.524 5.281L9.44 7.465 6.63 2.163 1 12.141Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol